import React, { FunctionComponent } from "react";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import useUserRole from "../../../utils/hooks/useUserRole";
import { CoachDashboardTabKeys } from "../../pages/coach-dashboard/CoachDashboard";
import { useIntl } from "react-intl";

type OwnProps = {};

type Props = OwnProps;

const SettingButton: FunctionComponent<Props> = (props) => {
  const { isCoach, isTeacher, isSupervisor } = useUserRole();
  const intl = useIntl();

  return isCoach || isTeacher || isSupervisor ? (
    <Nav.Item>
      <Nav.Link eventKey={CoachDashboardTabKeys.DATA_PERMISSIONS}>
        <FontAwesomeIcon icon={faShieldAlt} />
        &nbsp;
        {intl.formatMessage({
            id: "app.navigation.dashboardMenuPanel.dataPermissionsLabel",
          })}
      </Nav.Link>
    </Nav.Item>
  ) : null;
};

export default SettingButton;
